import { render, staticRenderFns } from "./set-report-status.vue?vue&type=template&id=0cc3edae&"
import script from "./set-report-status.js?vue&type=script&lang=js&"
export * from "./set-report-status.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports